module Meevo.Components.FileUpload {
    angular.module("meevo.components.fileupload", []);
}